import { useContext } from "react";
import { Container, Label } from "reactstrap";

//Common
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import DisplayData from "../common/DisplayData/DisplayData";
import Button from "../common/VFX-UI/Button/Button";
import BlockIcon from "../common/Icons/BlockIcon";
import ActivateIcon from "../common/Icons/ActivateIcon";

//App
import { UsersContext } from "../Users/UsersContainer";
import { UserViewProps } from "../../types";
import { EMPTY_GUID } from "../../utility/constants";
import useComponentGeneralStyles from "../styles";
import { maskPhone } from "../../utility/lib/format";
import { getFormattedDate } from "../../utility/helpers";
import { ResetIcon } from "../common/Icons";
import { LookupDto } from "../../app/model/api/types/dto";

const UserView = (props: UserViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
    toggleResetPasswordHandler,
  } = props;
  const usersContext = useContext(UsersContext);
  const generalStyles = useComponentGeneralStyles();
  const user = usersContext?.data;
  const maskedNumber = user?.phoneNumber ? maskPhone(user?.phoneNumber) : "";
  const role: LookupDto = usersContext?.lookupsData?.find(
    (lookup: { id: string }) =>
      lookup.id?.toLowerCase() === user?.roleId?.toLowerCase()
  );
  return (
    <FormBackGround>
      <FormHeader
        title="View User"
        chipLabel={
          user?.status ??
          (user?.isActive === undefined || user?.isActive === null
            ? undefined
            : user.isActive ? "Active" : "Inactive")
        }
        onClose={onClose}
        editActionHandler={user?.isActive ? editAction : undefined}
      />

      <DisplayData text="First Name" importedData={user?.firstName} />
      <DisplayData text="Last Name" importedData={user?.lastName} />

      <Label
        style={generalStyles.sectionHeader}
        className="border-bottom my-3 pb-2"
      >
        Contact Information
      </Label>
      <DisplayData text="User Name" importedData={user?.userName} />
      <DisplayData text="Email" importedData={user?.email} />
      <DisplayData text="Phone Number" importedData={maskedNumber} />

      <Label
        style={generalStyles.sectionHeader}
        className="border-bottom my-3 pb-2"
      >
        System Information
      </Label>
      <DisplayData text="Role" importedData={role?.display ?? role?.name ?? ""} />
      {user?.createdDateUtc && (
        <DisplayData
          text=" Date Added"
          importedData={getFormattedDate(user?.createdDateUtc)}
        ></DisplayData>
      )}

      <div className="border-top container-fluid p-3  mt-auto">
        {usersContext?.id &&
          usersContext?.id !== EMPTY_GUID &&
          user?.canDeactivate && (
            <>
              <Button
                className="me-3"
                style={generalStyles.deleteButton}
                onClick={toggleDeactivateHandler}
              >
                <BlockIcon />
              </Button>
              {user?.canResetPassword && (
                <Button
                  style={generalStyles.activateButton}
                  onClick={toggleResetPasswordHandler}
                >
                  <ResetIcon />
                </Button>
              )}
            </>
          )}
        {usersContext?.id &&
          usersContext?.id !== EMPTY_GUID &&
          user?.canActivate && (
            <Container>
              <Button
                style={generalStyles.activateButton}
                onClick={toggleActivateHandler}
              >
                <ActivateIcon />
              </Button>
            </Container>
          )}
      </div>
    </FormBackGround>
  );
};

export default UserView;
